// 클라이언트 퍼널 이벤트 — Vercel Analytics track
import { track } from '@vercel/analytics';

export function trackEvent(name, props = {}) {
  try {
    track(name, props);
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', name, props, err);
    }
  }
}

export const AnalyticsEvents = {
  FINDER_COMPLETE: 'finder_complete',
  CHECKLIST_COPY: 'checklist_copy',
  GUIDE_CTA_CONSULT: 'guide_cta_consult',
  PASS_SUBMIT: 'pass_submit',
  CONSULT_SUBMIT: 'consult_submit',
  RESOURCE_OUTBOUND: 'resource_outbound',
};
